import React from "react"
import { Chip, IconButton, FontIcon } from "material-ui"
import autobind from "class-autobind"
import strings from "../../localization/strings"
import * as hierarchyHelper from "../../helpers/hierarchyHelper"
import ChoosePayrollHierarchyDialogForChip from "./ChoosePayrollHierarchyDialogForChip"

interface IProps {
    selectedPayrollHierarchyIds: string[]
    handleChange(selectedPayrollHierarchyIds: string[]): void
}
interface IState {
    selectedPayrollHierarchyIds: string[]
    openChoosePayrollHierarchyDialog: boolean
}

export default class MultiPayrollHierarchyChips extends React.Component<IProps, IState> {
    constructor(props: IProps) {
        super(props)
        this.state = {
            selectedPayrollHierarchyIds: [],
            openChoosePayrollHierarchyDialog: false,
        }
        autobind(this)
    }

    render() {
        return (
            <div>
                <div>
                    <span>{strings.Payroll_Hierarchy}</span>
                </div>
                <div style={{ display: "flex", flexWrap: "wrap" }}>
                    {this.state.selectedPayrollHierarchyIds.length > 0 &&
                        this.state.selectedPayrollHierarchyIds.map(payrollHierarchyId =>
                            <Chip
                                key={payrollHierarchyId}
                                style={{ margin: 5, cursor: "pointer" }}
                                onRequestDelete={() => {
                                    const selectedPayrollHierarchyIds = this.state.selectedPayrollHierarchyIds.filter(i => i !== payrollHierarchyId)
                                    this.setState({ selectedPayrollHierarchyIds })
                                    this.props.handleChange(selectedPayrollHierarchyIds)
                                }}
                            >
                                {hierarchyHelper.getFullyQualifiedLevelNameById(payrollHierarchyId)}
                            </Chip>
                        )
                    }
                    <IconButton
                        style={{ height: 35, width: 35, padding: 0, margin: 0, display: "inline-block" }}
                        onTouchTap={() => this.setState({ openChoosePayrollHierarchyDialog: true })}
                    >
                        <FontIcon className="fa fa-plus-circle" />
                    </IconButton>
                </div>
                {this.state.openChoosePayrollHierarchyDialog &&
                    <ChoosePayrollHierarchyDialogForChip
                        selectedPayrollHierarchyIds={this.state.selectedPayrollHierarchyIds}
                        handleClose={() => this.setState({ openChoosePayrollHierarchyDialog: false })}
                        handleSelect={payrollHierarchyIds => {
                            let selectedPayrollHierarchyIds = this.state.selectedPayrollHierarchyIds
                            selectedPayrollHierarchyIds = selectedPayrollHierarchyIds.concat(payrollHierarchyIds)
                            this.setState({ selectedPayrollHierarchyIds, openChoosePayrollHierarchyDialog: false })
                            this.props.handleChange(selectedPayrollHierarchyIds)
                        }}
                    />
                }
            </div>
        )
    }
}